<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-70">
      <Loading :loading.sync="loadingDados" />
      <graphic-area
        v-if="!loadingDados"
        :tipo="`${sensor.codigoIntegracao} - ${sensor.descricao}`"
        :sensores="[{ descricao: sensor.descricao, dados: dadosSensor }]"
        :height="'250vh'"
      />
    </div>
    <div class="md-layout-item md-size-30">
      <span class="md-body-1"
        ><b>Código:</b> {{ sensor.codigoIntegracao }}</span
      >
      <br />
      <span class="md-body-1"><b>Tipo:</b> {{ sensor.tipoSensor }}</span>
      <br />
      <span class="md-body-1"><b>Descrição:</b> {{ sensor.descricao }}</span>
      <br />
      <md-field :class="getValidationClass('valorAvulso')">
        <label for="telefoneDoProprietario">Valor avulso</label>
        <md-input v-model.number="form.valorAvulso" type="number" />
        <span v-if="!$v.form.valorAvulso.required" class="md-error"
          >Valor é obrigatório</span
        >
      </md-field>
      <md-button class="md-raised md-accent" @click="cancelar">
        Voltar
      </md-button>
      <md-button class="md-raised md-primary" type="submit" @click="submit">
        Salvar
      </md-button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../utils/http'
import GraphicArea from '../GraphicArea'
import Loading from '../Loading'

export default {
  name: 'EquipamentoEnviarDadoAvulso',
  components: { Loading, GraphicArea },
  mixins: [validationMixin],
  props: {
    equipamentoId: String,
    sensor: Object,
  },
  data() {
    return {
      form: {
        valorAvulso: null,
      },
      dadosSensor: [],
      loadingDados: true,
    }
  },
  validations: {
    form: {
      valorAvulso: { required },
    },
  },
  async created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loadingDados = true
      this.dadosSensor = (await http.get(`sensor/${this.sensor.id}`)).dados.map(
        (e) => [new Date(e.horarioColeta).utcToLocalDate().valueOf(), e.valor]
      )
      this.loadingDados = false
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    cancelar() {
      this.$emit('onCancel')
    },
    async submit() {
      this.loadingDados = true

      await http.post(`equipamento/${this.equipamentoId}/dados/avulso`, {
        equipamentoCampoId: this.equipamentoId,
        dados: [
          {
            codigoIntegracao: this.sensor.codigoIntegracao,
            valor: this.form.valorAvulso,
          },
        ],
      })

      this.$emit('change')

      await this.fetchData()
    },
  },
}
</script>

<style scoped></style>
